import { EVENTS, Event } from '../../lib/events'
import { useState, useEffect } from 'react'

export const Events = () => {
  const [event, setEvent] = useState<Event|null>(null)
  
  useEffect(() => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const currentEvent = EVENTS.find((e) => {
      e.date.setHours(0, 0, 0, 0)
      return e.date.getTime() === today.getTime()
    })
    if(currentEvent) {
      setEvent(currentEvent)
    }
  }, [])
  
  return <>{event && <div className="p-1 my-8 dark:text-white">{event.copy}</div>}</>
}
